import { Dialog, DialogContent } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export default function AgeGate({ onVerified }) {
  return (
    <Dialog open={true}>
      <DialogContent className="sm:max-w-md" hideClose>
        <div className="text-center space-y-6 py-6">
          <img 
            src="https://customer-assets.emergentagent.com/job_craft-beer-shop-1/artifacts/5xgb6py8_LOGO%20SEUL.png"
            alt="Soif de Provence Logo"
            className="h-16 w-16 object-contain mx-auto"
          />
          <h2 className="text-3xl font-heading text-foreground">Bienvenue</h2>
          <p className="text-lg text-muted-foreground">
            Vous devez avoir 18 ans ou plus pour accéder à ce site.
          </p>
          <Button
            onClick={onVerified}
            className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-full py-6 text-lg font-medium transition-transform hover:-translate-y-1 shadow-lg hover:shadow-xl"
            data-testid="age-gate-confirm-button"
          >
            J'ai plus de 18 ans
          </Button>
          <p className="text-xs text-muted-foreground">
            L'abus d'alcool est dangereux pour la santé, à consommer avec modération.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}